import { myAxios } from "../../utils/serverContextPath";

// =======================================================
// CRUD
// =======================================================

export const postForumTopic = (data) => {
    return myAxios.post("forumtopic/save/insert", data);
};

export const updateForumTopic = (data) => {
    return myAxios.post("forumtopic/save/update", data);
};

export const getForumTopicById = (id) => {
    return myAxios.get(`forumtopic/getbyid/${id}`);
};

export const getForumTopicAllPage = (
    keyword = "",
    pageNumber = 0,
    itemsPerPage = 10,
    sortList = [],
    sortOrder = "DESC"
) => {

    
    return myAxios.get("forumtopic/getallpage", {
        params: {
            keyword,
            page: pageNumber,
            size: itemsPerPage,
            sortList,
            sortOrder
        }
    })
    
    
    ;

};

export const getAllForumTopic = (
    keyword = "",
    sortList = [],
    sortOrder = "DESC"
) => {

    return myAxios.get("forumtopic/getall", {
        params: {
            keyword,
            sortList,
            sortOrder
        }
    });

};

export const deleteForumTopic = (id) => {
    return myAxios.delete(`forumtopic/delete/${id}`);
};

// =======================================================
// Recherche
// =======================================================

export const findSimilarForumTopic = (
    keyword,
    tauxsimilarity = 0.6,
    sortList = [],
    sortOrder = "DESC"
) => {

    return myAxios.get("forumtopic/similarity", {
        params: {
            keyword,
            tauxsimilarity,
            sortList,
            sortOrder
        }
    });

};

// =======================================================
// Métier
// =======================================================

export const incrementViews = (id) => {
  return myAxios.post(`forumtopic/incrementviews/${id}`);
};

export const incrementLikes = (id) => {
  return myAxios.post(`forumtopic/incrementlikes/${id}`);
};

export const decrementLikes = (id) => {
  return myAxios.post(`forumtopic/decrementlikes/${id}`);
};


export const incrementNbMessages = (id) => {
    return myAxios.post(
        `forumtopic/incrementnbmessages/${id}`
    );
};


export const decrementNbMessages = (id) => {
    return myAxios.post(
        `forumtopic/decrementnbmessages/${id}`
    );
};



export const uploadFileToForumTopic = (id,index,formData) => {
    return myAxios.post(
        `forumtopic/uploadfile/${id}/${index}`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
};

export const downloadFileFromForumTopic = (id,index) => {
    return myAxios.get(`forumtopic/downloadfile/${id}/${index}`, {
        responseType: "blob",
    });

};

export const countTopics = (
) => {
    return myAxios.get("forumtopic/counttopics", {
    });
};

export const sumViews = (
) => {
    return myAxios.get("forumtopic/sumviews", {
    });
};

export const sumLikes = (
) => {
    return myAxios.get("forumtopic/sumlikes", {
    });
};